/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export * from './create-shortcuts-plugin';
export * from './shortcuts-contribution';
